import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { PartListOrSingleItem } from '@v2/pages/machines/modules/now/components/Part/components/PartListOrSingleItem';

interface PartDetailsPartProps {
  partId: number | null;
}

const PartDetailsPartComponent: FC<PartDetailsPartProps> = ({
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  partId,
}) => {
  const title = useTitle();

  const { partDataLoading } = usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    updateHeaderConfig,
    getProductionBatchByPart,
    getPartByID,
    operationsSearch,
  });

  return (
    <DetailsPageWrapper title={title.part}>
        <PartListOrSingleItem displaySinglePart partDataLoadingForList={partDataLoading} partId={partId} />
    </DetailsPageWrapper>
  );
};

const PartDetailsPart = connect(({ details: { partId } }) => ({ partId }), {
  clearTools,
  getNCFileByPartId,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsPartComponent);

export { PartDetailsPart };
